import React, { useState, useEffect } from 'react';

import { BsFillTrashFill } from 'react-icons/bs';

import Moment from 'moment';
import { toast } from 'react-toastify';

import api from '~/services/api';

import {
  Scroll,
  Container,
  Header,
  Area,
  Grid,
  GridLine,
  GridHeadItem,
  GridMenuItem,
  GridItem,
  Progress,
  Loading,
  Empty,
} from '~/components';

import AvisoType from '~/@types/aviso';
import { DismissButton } from './styles';

let lang = require('moment/locale/pt-br');
Moment.locale('pt-br', lang);

const Notificacoes: React.FC = () => {
  const [inLoad, setInLoad] = useState(false);
  const [notificacoes, setNotificacoes] = useState<AvisoType[]>([]);

  const fetchAvisos = async () => {
    try {
      setInLoad(true);
      setNotificacoes([]);

      const response = await api.get(`avisos-internos/todos`);

      const { data } = response;

      if (data && data.length) {
        setNotificacoes(data);
      }

      setInLoad(false);
    } catch (e) {
      setInLoad(false);
    }
  };

  const removerAviso = async (id: string) => {
    try {
      const response = await api.delete(`avisos-internos?id=${id}`);

      const { data } = response;
      if (data && !data.error) {
        fetchAvisos();
      } else {
        toast.error(data.message);
      }
    } catch (e) {
      toast.error(`${(e as Error).message}`);
    }
  };

  useEffect(() => {
    fetchAvisos();
  }, []);

  return (
    <>
      {inLoad ? <Progress /> : null}

      <Scroll>
        <Container>
          <Header
            title="Notificações"
            subtitle="Confiras os seus avisos, notificações e atualizações"
          />

          {!inLoad ? (
            <Area>
              {notificacoes.length ? (
                <Grid>
                  <GridLine>
                    <GridHeadItem title="Mensagem" />
                    <GridHeadItem title="Data" width={200} />
                    <GridMenuItem />
                  </GridLine>

                  {notificacoes.map((aviso, key) => (
                    <GridLine key={aviso.idaviso}>
                      <GridItem>{aviso.mensagem}</GridItem>
                      <GridItem width={200}>
                        <strong>
                          {Moment(aviso.ts).format('DD/mm/YYYY HH:mm')}
                        </strong>
                        <br />
                        <small>{Moment(aviso.ts).fromNow()}</small>
                      </GridItem>
                      <GridItem>
                        <DismissButton onClick={() => removerAviso(aviso.idaviso)}>
                          <BsFillTrashFill size={22} color="#333" />
                        </DismissButton>
                      </GridItem>
                    </GridLine>
                  ))}
                </Grid>
              ) : (
                <Empty>Nenhuma notificação encontrada.</Empty>
              )}
            </Area>
          ) : (
            <Loading color="#333" />
          )}
        </Container>
      </Scroll>
    </>
  );
};

export default Notificacoes;
